import { useStaticQuery } from "gatsby";
import React from "react";

import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const ImageComponent = ({ fileName, alt, style }) => {
  
  const { allFile } = useStaticQuery(graphql`
    query {
      allFile(filter: { sourceInstanceName: { eq: "images" } }) {
        nodes {
          relativePath
          childImageSharp {
            gatsbyImageData(
              layout: FULL_WIDTH
              formats: WEBP
              placeholder: BLURRED
            )
          }
        }
      }
    }
  `);
  const image = allFile?.nodes.find((n) => n.relativePath === fileName)
    ?.childImageSharp?.gatsbyImageData;

  return <GatsbyImage image={image} alt={alt} style={style} />;
};

export default ImageComponent;
